import { Component, ViewChild } from '@angular/core';
import { SwiperComponent } from 'swiper/angular';

@Component({
  selector: 'app-reviews-home',
  templateUrl: './reviews-home.component.html',
  styleUrl: './reviews-home.component.scss'
})
export class ReviewsHomeComponent {

  @ViewChild(SwiperComponent) swiper?: SwiperComponent | any;
  public swiperConfig: any = {
    allowTouchMove: true,
    slidesPerView: 1,
    spaceBetween: 0,
    centeredSlides: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    speed: 800,
    autoHeight: false,
  };

  public loader: boolean = false;

  public reviews: any[] = [
    {
      rating: 5,
      authorAttribution: {
        displayName: 'María González Hernández',
        photoUri: '/assets/images/testimonials/maria.svg'
      },
      publishTime: '2024-01-15T10:30:00Z',
      originalText: {
        text: 'Excelente servicio de Paredes y Asociados. La remodelación de nuestras oficinas quedó espectacular, cumpliendo con todos los estándares de calidad y en el tiempo acordado.'
      }
    },
    {
      rating: 5,
      authorAttribution: {
        displayName: 'Carlos Ramírez López',
        photoUri: '/assets/images/testimonials/carlos.svg'
      },
      publishTime: '2024-02-08T14:20:00Z',
      originalText: {
        text: 'Muy recomendable. El equipo de Paredes y Asociados realizó la construcción de nuestra nave industrial con gran profesionalismo. La estructura es sólida y funcional.'
      }
    },
    {
      rating: 5,
      authorAttribution: {
        displayName: 'Ana Patricia Morales',
        photoUri: '/assets/images/testimonials/ana.svg'
      },
      publishTime: '2024-01-28T16:45:00Z',
      originalText: {
        text: 'Desde el primer contacto me sentí en confianza. Paredes y Asociados construyó la casa de mis sueños cuidando cada detalle arquitectónico. Materiales de primera calidad.'
      }
    },
    {
      rating: 5,
      authorAttribution: {
        displayName: 'Roberto Sánchez Vega',
        photoUri: '/assets/images/testimonials/roberto.svg'
      },
      publishTime: '2024-02-12T09:15:00Z',
      originalText: {
        text: 'Profesionalismo y transparencia en cada paso. La supervisión de obra fue impecable y el edificio de departamentos se entregó sin contratiempos. Una constructora muy seria.'
      }
    },
    {
      rating: 5,
      authorAttribution: {
        displayName: 'Lucía Fernández Castro',
        photoUri: '/assets/images/testimonials/lucia.svg'
      },
      publishTime: '2024-01-22T11:30:00Z',
      originalText: {
        text: 'La mejor decisión que pude tomar. El proyecto de ampliación de mi local comercial se adaptó perfectamente a mis necesidades y presupuesto. Gran trabajo de ingeniería.'
      }
    },
    {
      rating: 5,
      authorAttribution: {
        displayName: 'Miguel Ángel Torres',
        photoUri: '/assets/images/testimonials/miguel.svg'
      },
      publishTime: '2024-02-05T13:20:00Z',
      originalText: {
        text: 'Atención excepcional y resultados garantizados. La rehabilitación de la fachada de nuestro edificio histórico fue un éxito. Respetaron el estilo original con técnicas modernas.'
      }
    }
  ];

  constructor() { }

  onImgError(event: Event) {
    (event.target as HTMLImageElement).style.display = 'none';
    (event.target as HTMLImageElement).parentElement!.classList.add('fallback');
  }


}
